export var IPublicEnumContextMenuType = /*#__PURE__*/function (IPublicEnumContextMenuType) {
  IPublicEnumContextMenuType["SEPARATOR"] = "separator";
  // 'menuItem'
  IPublicEnumContextMenuType["MENU_ITEM"] = "menuItem";
  // 'nodeTree'
  IPublicEnumContextMenuType["NODE_TREE"] = "nodeTree";
  return IPublicEnumContextMenuType;
}({});